import * as React from "react";
const SvgFiRrGovernmentUser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-government-user_svg__a)">
      <path
        fill="#062147"
        d="M10 10c2.757 0 5-2.243 5-5s-2.243-5-5-5-5 2.243-5 5 2.243 5 5 5m0-8c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m9 17h-1c0-4.411-3.589-8-8-8s-8 3.589-8 8H1a1 1 0 1 0 0 2v2a1 1 0 1 0 2 0v-2h14v2a1 1 0 1 0 2 0v-2a1 1 0 1 0 0-2M8.25 19H4c0-2.573 1.631-4.767 3.911-5.617l1.269 1.904zm3.499 0-.93-3.713 1.269-1.904c2.28.851 3.911 3.044 3.911 5.617zM24 1a1 1 0 0 1-1 1v5.347c0 .623-.791.89-1.169.395L20.5 5.999l-1.331 1.743C18.791 8.237 18 7.97 18 7.347V2a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-government-user_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGovernmentUser;
